const message = {
  header: {
    site: 'în parteneriat cu',
    title: 'Ghicește scorul, câștigă cadouri și',
    shortDescription: `Toți microbiștii înrăiți să se adune aici. 
    Se anunță multe premii cool pentru cei ce vor prognoza corect
     scorul celor 64 de meciuri ce vor avea loc în cadrul Campionatului Mondial de Fotbal 2022:
     televizoare, Microsoft Xbox Series S, Aparate de Cafea și tehnică utilă pentru casă...`,
    description: `Toți microbiștii înrăiți să se adune aici. 
    Se anunță multe premii cool pentru cei ce vor prognoza corect <br />
     scorul celor 64 de meciuri ce vor avea loc în cadrul Campionatului Mondial de Fotbal 2022: <br />
    televizoare, Microsoft Xbox Series S, Aparate de Cafea și tehnică utilă pentru casă. <br />
    Pe lângă aceste premii, poți câștiga după fiecare meci prognozat corect bonusuri valoroase eLei.
    <br /><br />
    Deci, știi ce ai de făcut? Urmărește meciurile, ghicește scorul, acumulează puncte, <br/>
     fii pe locul 1 în tabel ➡ câștigă premii valoroase și bonusuri eLei.`,
    more: 'detalii',
    less: 'ascunde'
  },
  navbar: {
    predict: 'Pronostic',
    rules: 'Reguli',
    list: 'Clasament',
    gifts: 'Premii',
    menu: 'Meniu',
    notify: 'Abonați-vă la notificări',
    chat: 'Chat'
  },
  hack: {
    warning: 'Atenție!',
    tooLong: 'Ați introdus o valoare prea mare!'
  },
  account: {
    points: 'puncte',
    logout: 'logout'
  },
  auth: {
    auth: 'Autorizare',
    mail: 'Email',
    pass: 'Parola',
    repass: 'Parola repetată',
    login: 'Logare',
    orWith: 'Sau cu ajutorul:',
    notAuth: 'Nu aveți un cont ?',
    reg: 'Înregistrare',
    required: 'Câmp obligatoriu',
    name: 'Prenume',
    surname: 'Nume',
    birthDate: 'Data de naștere',
    phone: 'Telefon',
    confirm: 'Confirmă',
    datePicker: 'ro-Latn',
    warning: 'Atenție!',
    field_required: 'Pentru a continua, este necesar să îndepliniți toate cîmpurile.',
    password_math: 'Parola dvs. nu coincide.',
    error: 'Eroare!',
    auth_fail: 'Autorizarea nu a trecut.',
    auth_to_save: 'Pentru a salva scorul trebuie să vă autorizați.',
    recovery: 'Ați uitat parola?',
    recover: 'Restabilește',
    recoveryTitle: `Restabilire parolă`,
    recoveryText: `Pentru a reseta parola, trebuie să introduceți <b>adresa mail</b> și <b>numărul de telefon</b> indicat la registrare.`,
    agreeText: `Am luat cunostinta cu <a href="/static/document/regulament.pdf" target="_blank">Regulamentul</a>`
  },
  pages: {
    predict: 'Pronostic',
    rules: 'Reguli',
    gifts: 'Premii',
    rank: 'Clasament'
  },
  footer: {
    contact: 'Aveți întrebări? Apelați-ne:'
  },
  gift: {
    place: 'loc',
    tv: 'Televizor',
    shoes: 'Adidași SMART',
    handsfree: 'Căști fără fir',
    smartband: 'Brățară inteligentă',
    ball: 'Minge de fotbal',
    bag: 'Rucsac',
    footer: {
      title: '',
      text: ``
    }
  },
  rules: {
    list: [
      {
        title: 'Când și cum intru în concurs?',
        description: `
        Poți intra în goana după premii oricând dorești! <br />
        Singura condiție e să fie-n perioada 20 noiembrie – 18 decembrie 2022 (durata Campionatului Mondial de Fotbal 2022). <br />
        Tot ce trebuie să ai e: un cont personal activ de Facebook, ori unul de Google. <br />
        Dacă n-ai nici una, nici alta, te poți înscrie manual, direct pe platformă.`
      },
      {
        title: 'Ce trebuie să fac?',
        description: `
        Mecanica concursului e pe cât se poate de simplă. <br><br/>
        1. După ce te-ai înscris pe platformă, ești considerat automat participant în concurs.<br>
        2. Prognozează și completează scorul celor 64 de meciuri disputate în Campionatul Mondial de Fotbal 2022.<br>
        3. Acumulează puncte în funcție de pronostic:<br>
        <br>
        • În cazul în care ghicești echipa câștigătoare a partidei, acumulezi 1 punct;<br>
        • În cazul în care ghicești scorul final al partidei, acumulezi 3 puncte;<br>
        • În cazul în care nu ghicești nici câștigătorul și nici scorul, acumulezi 0 puncte.<br>
        • Pentru meciurile necompletate, se va considera lipsă răspuns, adică 0 puncte.  
        `
      },
      {
        title: 'Cum câștig?',
        description: `
         Punem la bătaie multe premii interesante și valoroase! Printre care și eLei, pe care îi poți câștiga chiar după fiecare meci. 
         Clasamentul final va fi alcătuit conform punctajului acumulat de participanți, în ordine descrescătoare. Astfel, 
         Marele Premiu va fi câștigat de cel cu cele mai multe puncte acumulate.
        `
      }],
    download: 'Descarcă Regulamentul detaliat'
  },
  rank: 'Pagina se află în curs de actualizare...',
  game: {
    start: 'Meciul a început',
    finish: 'Meciul a luat sfîrșit',
    enterPredict: 'Introduceți prognoza',
    gotPredict: `Prognoza dvs. a fost acceptată<br> Vă urăm succes!`,
    toolate: `Nu ați reușit<br>să faceți o prognoză!`,
    needAuth: 'Necesită autorizare',
    winner: 'Felicitări!',
    got: 'Ați primit',
    points: 'puncte',
    point: 'punct',
    noPoints: 'puncte',
    yourScore: 'Scorul introdus'
  },
  champions: {
    login: 'Autorizați-vă pentru a vedea rezultatul.',
    place: 'LOCUL',
    user: 'PARTICIPANT',
    points: 'PUNCTE'
  },
  dialog: {
    title: 'Nu rata niciun meci',
    text: 'Urmărește ultimile știri <br> și discută rezultatele meciurilor'
  },
  banners: {
    btn: 'Alege'
  }
}

export default message



// WEBPACK FOOTER //
// ./src/lang/ro.js